module.exports = __webpack_public_path__ + "img/刘洋.212a4ed5.jpg";